import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoProps {
    tone?: 'dark' | 'light'
    size?: 'sm' | 'md' | 'lg'
    withText?: boolean
    href?: string | null
    className?: string
}

const SIZES = {
    sm: 'size-11',
    md: 'size-14',
    lg: 'size-20'
}

export const LogoMark: FC<{ tone?: 'dark' | 'light', size?: 'sm' | 'md' | 'lg', className?: string }> = ({ tone = 'dark', size = 'md', className }): ReactNode => (
    // eslint-disable-next-line @next/next/no-img-element
    <img
        src='/images/logo.png'
        alt=''
        width={160}
        height={160}
        decoding='async'
        className={cn(SIZES[size], 'shrink-0 select-none', tone === 'light' ? 'logo-on-dark' : 'logo-blend', className)}
    />
)

export const Logo: FC<LogoProps> = ({ tone = 'dark', size = 'md', withText = true, href = '/', className }): ReactNode => {
    const content = (
        <>
            <LogoMark tone={tone} size={size} />

            {withText && (
                <span className='flex flex-col leading-none' dir='ltr'>
                    <span className={cn('font-heading text-[19px] font-semibold tracking-[0.16em]', tone === 'light' ? 'text-white' : 'text-navy')}>
                        URLAUB DE LUXE
                    </span>
                    <span className='mt-1 text-[10px] font-bold tracking-[0.5em] text-gold'>
                        TUNESIEN
                    </span>
                </span>
            )}
        </>
    )

    if (!href) return <span className={cn('flex items-center gap-3', className)}>{content}</span>

    return (
        <Link href={href} aria-label={siteConfig.name} className={cn('flex items-center gap-3 rounded-lg focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold', className)}>
            {content}
        </Link>
    )
}
